<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import configs from '../../config';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCrown } from '@fortawesome/free-solid-svg-icons';
    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = false
    let bnakDep = {}
    let names;

    let myRanking = []
    let myScore = 0
    let isList=  false
    let isError = false

    let cashback_ufa
    let cashback_lsm
    let cashback_gmz
    let cashback_mrg
    let percentagex = 0

    async function gethistory() {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getmyranking", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            if(json.payload.status==1){
                myRanking = json.payload.data
                cashback_ufa = JSON.parse(myRanking.cashback_ufa)
                cashback_lsm = JSON.parse(myRanking.cashback_lsm)
                cashback_gmz = JSON.parse(myRanking.cashback_gmz)
                // rank เก่าอาจยังไม่มี field cashback_mrg
                cashback_mrg = myRanking.cashback_mrg ? JSON.parse(myRanking.cashback_mrg) : {status:'C'}
                myScore = json.payload.scores
                let setA = myRanking.up_max-myRanking.up_min
                let setB = myScore-myRanking.up_min
                percentagex = Math.ceil((100*setB)/setA)
                isList = true
                isError = false
            }else{
                isError = true
                isList = false
            }
		} else {
            throw new Error(json);
		}
    }
    $: {
        gethistory()
    }
    
</script>
<div class="default-home">
<div class="row   mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
    
   
    <div class="col-12 text-center mt-2" ><h4 style="color: rgb(230, 196, 119) !important;"><Fa icon={faCrown} /> Ranking</h4></div>
    <div class="col-12" style="min-height: 500px;">
        <div class="col-12" style="text-align: center;">
            <div class="card mt-2 bg-black mb-5">
                {#if isError}
                <h5 style="color: #FFF;margin-top:30px;"> Coming soon.</h5>
                {/if}
                {#if isList}
                <div class="card-body text-center text-white">
                    <img class="img-fluid" src="{myRanking.rank_img}" style="max-width: 150px;" />
                    <h5 class="mt-2 mb-0">{myRanking.rank_name}</h5>
                    <small class="text-warning">{myRanking.up_min.toLocaleString("en-US")} - {myRanking.up_max.toLocaleString("en-US")}</small>
                    <div class="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="{percentagex}" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-info" style="width: {percentagex}%"><span >{percentagex}%</span></div>
                    </div>
                    <h6 class="mt-2 mb-0"><span class="text-info">{myScore.toLocaleString("en-US")}</span> scores</h6>
                    <div class="row">
                        <div class="col-12 text-center mt-2"><h6>สิทธิพิเศษ</h6></div>
                        {#if myRanking.cashback_status=='O'}
                        <div class="col-12 text-start mt-2 text-warning"><h6>คืนยอดเสีย</h6></div>
                        {#if cashback_ufa.status=='O'}
                        <div class="col-4 text-center "><img decoding="async" src="./assets/platform/UFA.png" alt="UFABET" class="img-fluid"> <br /> <span class="text-warning">{cashback_ufa.cashback_all}%</span></div>
                        {/if}
                        {#if cashback_mrg.status=='O'}
                        <div class="col-4 text-center "><img decoding="async" src="./assets/platform/MRG.png" alt="MRGBET" class="img-fluid"> <br /> <span class="text-warning">{cashback_mrg.cashback_all}%</span></div>
                        {/if}
                        {#if cashback_lsm.status=='O'}
                        <div class="col-4 text-center">
                            <img decoding="async" src="./assets/platform/LSM.png" alt="UFABET" class="img-fluid"><br />
                            <small class="text-warning">Sport : {cashback_lsm.cashback_sport}%</small><br />
                            <small class="text-warning">Casino : {cashback_lsm.cashback_casino}%</small><br />
                            <small class="text-warning">Slot : {cashback_lsm.cashback_slot}%</small><br />
                            <small class="text-warning">Lotto : {cashback_lsm.cashback_lotto}%</small>
                        </div>
                        {/if}
                        {#if cashback_gmz.status=='O'}
                        <div class="col-4 text-center">
                            <img decoding="async" src="./assets/platform/{configs.gmz}.png" alt="AMB" class="img-fluid"><br />
                            <small class="text-warning">Sport : {cashback_gmz.cashback_sport}%</small><br />
                            <small class="text-warning">Casino : {cashback_gmz.cashback_casino}%</small><br />
                            <small class="text-warning">Slot : {cashback_gmz.cashback_slot}%</small><br />
                            <small class="text-warning">Lotto : {cashback_gmz.cashback_lotto}%</small>
                        </div>
                        {/if}
                        {/if}

                        {#if myRanking.point_status=='O'}
                        <div class="col-12 text-start text-info"><h6>สะสมแต้ม</h6></div>
                        <div class="col-12 text-start ">ฝาก {myRanking.rank_credit.toLocaleString("en-US")} รับ {myRanking.rank_point} แต้ม</div>
                        {/if}
                        

                    </div>

                </div>
                
                {/if}
            </div>
        </div>
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-promotion">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4 class="head-title"><Fa icon={faCrown} /> รางวัล</h4></div>
        <div class="col-12" style="min-height: 500px;">
            <div class="col-12" style="text-align: center;">
                <div class="card mt-3 bg-black mb-5">
                    {#if isError}
                    <h5 style="color: #FFF;margin-top:30px;"> Coming soon.</h5>
                    {/if}
                    {#if isList}
                    <div class="card-body text-center text-white">
                        <img class="img-fluid" src="{myRanking.rank_img}" style="max-width: 150px;" />
                        <h5 class="mt-2 mb-0">{myRanking.rank_name}</h5>
                        <small class="text-warning">{myRanking.up_min.toLocaleString("en-US")} - {myRanking.up_max.toLocaleString("en-US")}</small>
                        <div class="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="{percentagex}" aria-valuemin="0" aria-valuemax="100">
                            <div class="progress-bar progress-bar-striped progress-bar-animated bg-info" style="width: {percentagex}%"><span >{percentagex}%</span></div>
                        </div>
                        <h6 class="mt-2 mb-0"><span class="text-info">{myScore.toLocaleString("en-US")}</span> scores</h6>
                        <div class="row">
                            <div class="col-12 text-center mt-2"><h6>สิทธิพิเศษ</h6></div>
                            {#if myRanking.cashback_status=='O'}
                            <div class="col-12 text-start mt-2 text-warning"><h6>คืนยอดเสีย</h6></div>
                            {#if cashback_ufa.status=='O'}
                            <div class="col-4 text-center "><img decoding="async" src="./assets/platform/UFA.png" alt="UFABET" class="img-fluid"> <br /> <span class="text-warning">{cashback_ufa.cashback_all}%</span></div>
                            {/if}
                            {#if cashback_mrg.status=='O'}
                            <div class="col-4 text-center "><img decoding="async" src="./assets/platform/MRG.png" alt="MRGBET" class="img-fluid"> <br /> <span class="text-warning">{cashback_mrg.cashback_all}%</span></div>
                            {/if}
                            {#if cashback_lsm.status=='O'}
                            <div class="col-4 text-center">
                                <img decoding="async" src="./assets/platform/LSM.png" alt="UFABET" class="img-fluid"><br />
                                <small class="text-warning">Sport : {cashback_lsm.cashback_sport}%</small><br />
                                <small class="text-warning">Casino : {cashback_lsm.cashback_casino}%</small><br />
                                <small class="text-warning">Slot : {cashback_lsm.cashback_slot}%</small><br />
                                <small class="text-warning">Lotto : {cashback_lsm.cashback_lotto}%</small>
                            </div>
                            {/if}
                            {#if cashback_gmz.status=='O'}
                            <div class="col-4 text-center">
                                <img decoding="async" src="./assets/platform/{configs.gmz}.png" alt="AMB" class="img-fluid"><br />
                                <small class="text-warning">Sport : {cashback_gmz.cashback_sport}%</small><br />
                                <small class="text-warning">Casino : {cashback_gmz.cashback_casino}%</small><br />
                                <small class="text-warning">Slot : {cashback_gmz.cashback_slot}%</small><br />
                                <small class="text-warning">Lotto : {cashback_gmz.cashback_lotto}%</small>
                            </div>
                            {/if}
                            {/if}
    
                            {#if myRanking.point_status=='O'}
                            <div class="col-12 text-start text-info"><h6>สะสมแต้ม</h6></div>
                            <div class="col-12 text-start ">ฝาก {myRanking.rank_credit.toLocaleString("en-US")} รับ {myRanking.rank_point} แต้ม</div>
                            {/if}
                            
    
                        </div>
    
                    </div>
                    
                    {/if}
                </div>
            </div>
        </div>
        </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
</style>